import React, { createContext, useContext } from 'react';
import { IModelPredictionStoreMST } from 'modules/Predictions/mst/ModelPredictionStore';
import { IWorkflowPredictionStoreMST } from 'modules/Predictions/mst/WorkflowPredictionStore';
import { TIBasePredictionStoreMST } from '../mst/types';

export const MstPredictionStoreCtx = createContext<unknown | null>(null);

// giving a different name cause existing implementations also have `usePredictionStore`
export function useMstPredictionStore<
  TEntity extends CF.API.Workflows.Workflow | CF.API.Models.Model,
  U = TIBasePredictionStoreMST<TEntity>,
>(): U | null {
  return useContext<U | null>(MstPredictionStoreCtx as React.Context<U | null>);
}

/**
 *
 * ALWAYS ONLY USE IN COMPONENTS WRAPPED WITH withGuaranteedPredStore HOC TO AVOID RUNTIME BUGS
 *
 * Use this only if you have guaranteed that this hook is rendered as a child of
 * `MstPredictionStoreCtx`. Otherwise; it will be null and cause runtime errors.
 * In case of ModelViewer components, we do a null check and make sure all children
 * are rendered only if store exists. That is why we use this to avoid `store?.` checks.
 * */
export function useUnsafePredictionStore<
  TEntity extends CF.API.Workflows.Workflow | CF.API.Models.Model,
  U extends TIBasePredictionStoreMST<TEntity>,
>(): U {
  return useContext<U>(MstPredictionStoreCtx as React.Context<U>);
}

export function useUnsafePredictionStoreG<T extends IModelPredictionStoreMST | IWorkflowPredictionStoreMST>(): T {
  return useContext<T>(MstPredictionStoreCtx as React.Context<T>);
}
